import { render, staticRenderFns } from "./retouch.vue?vue&type=template&id=2f1f5432&scoped=true&"
import script from "./retouch.vue?vue&type=script&lang=js&"
export * from "./retouch.vue?vue&type=script&lang=js&"
import style0 from "./retouch.vue?vue&type=style&index=0&id=2f1f5432&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f5432",
  null
  
)

export default component.exports